import React from "react";
import Breakpoint from "react-socks";

const AboutMe = () => {
  return (
    <div>
      <section id="about-me">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h1 className="title-2 title-md-2">About me</h1>
              <p className="text-5 text-md-3 py-4">
                Hello, I&apos;m Vipul, a Software Engineer based in Singapore.
              </p>
              <h1 className="title-2 title-md-3">I am</h1>
              <ul>
                <li>
                  <h6 className="title-5 title-md-3 color-lighter">
                    Professional:
                  </h6>
                  <p className="text-5 text-md-3">
                    I have 6+ years of professional experience in developing
                    production level software.
                  </p>
                </li>
                <li>
                  <h6 className="title-5 title-md-3 color-lighter">
                    Passionate:
                  </h6>
                  <p className="text-5 text-md-3">
                    I really enjoy what I do in my day to day job.
                  </p>
                </li>
                <li>
                  <h6 className="title-5 title-md-3 color-lighter">
                    Quick learner:
                  </h6>
                  <p className="text-5 text-md-3">
                    Give me any technology and 3-4 weeks and I am sure I can
                    produce some quality work.
                  </p>
                </li>
                <li>
                  <h6 className="title-5 title-md-3 color-lighter">
                    Committed:
                  </h6>
                  <p className="text-5 text-md-3">
                    Once I take responsibility of task I give my 200%
                    commitment to complete it.
                  </p>
                </li>
              </ul>
            </div>
            <div className="col-md-6 pl-4">
              <h1 className="title-2 title-md-2">My skills</h1>
              <div className="pt-4">
                <h6 className="title-5 title-md-3 color-lighter">Frontend:</h6>
                <p className="text-5 text-md-3">
                  HTML5, CSS, Flexbox, Angular6+, ReactJS, React Native, RxJS, JavaScript,
                  TypeScript, Responsive design, Microfrontend architecture and Frontend automation testing
                  using WebdriverIO, CucumberJS
                </p>
              </div>
              <div className="pt-4">
                <h6 className="title-5 title-md-3 color-lighter">Backend:</h6>
                <p className="text-5 text-md-3">
                  C# .NET, NodeJS, Django Python, Microservice architecture,
                  Docker, AWS, REST API Development, SQL, NoSQL, Database schema
                  design
                </p>
              </div>
            </div>
          </div>
        </div>
        <Breakpoint medium up>
          <div className="d-flex justify-content-center pt-md-5">
            <a href="#work-experience" className="btn-view-my-work">
              View my work
            </a>
          </div>
        </Breakpoint>
      </section>
    </div>
  );
};

export default AboutMe;
